module.exports = __webpack_public_path__ + "img/dashboard-package-request.e3fa0888.svg";